import { render, staticRenderFns } from "./promotion-viewer.vue?vue&type=template&id=044be633&scoped=true"
import script from "./promotion-viewer.vue?vue&type=script&lang=js"
export * from "./promotion-viewer.vue?vue&type=script&lang=js"
import style0 from "./promotion-viewer.vue?vue&type=style&index=0&id=044be633&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044be633",
  null
  
)

export default component.exports